import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "toggle"]
  static values = { mode: { type: String, default: "hamburger" } }

  connect() {
    this.boundKeydown = this.keydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  toggle(event) {
    event.preventDefault()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  open() {
    if (this.modeValue === "dropdown") {
      if (this.hasPanelTarget) {
        this.panelTarget.classList.remove("d-none")
      }
    } else if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("d-none")
      document.body.classList.add("site-stories-menu-open")
    }

    document.addEventListener("keydown", this.boundKeydown)
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "true")
    }
  }

  close() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("d-none")
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("d-none")
    }
    document.body.classList.remove("site-stories-menu-open")
    document.removeEventListener("keydown", this.boundKeydown)
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  isOpen() {
    if (this.modeValue === "dropdown") {
      return this.hasPanelTarget && !this.panelTarget.classList.contains("d-none")
    }

    return this.hasOverlayTarget && !this.overlayTarget.classList.contains("d-none")
  }
}
